import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import { smTitle } from '@ifca-root/react-component/src/global/TitleVariable'
import { TotalAmountFooter } from 'components/Footer/TotalAmountFooter'
import React, { useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { ARConsolidateEInvoiceDetailContent } from './ARConsolidateEInvoiceDetailContent'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { ConsolidateTable } from '../../../ARAPModule/ConsolidateTable/ConsolidateTable'
import { useGetCompanyNameQuery } from 'generated/graphql'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'

export const ARConsolidateEInvoiceDetail = (props: any) => {
  /*
  ===========================================
  =================VARIABLES=================
  ===========================================
  */
  let history = useHistory()
  let location = useLocation()
  const listData = location?.state as any
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { CompanyID }: any = useParams()

  /*
  ===========================================
  =================USE STATE=================
  ===========================================
  */
  const [labelState, setLabelState] = useState<string>()

  /*
  ====================================
  ==============QUERY=================
  ====================================
  */
  const {
    loading: CompanyLoading,
    error: CompanyError,
    data: { getCompany } = { getCompany: [] },
  } = useGetCompanyNameQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID },
    onCompleted: () => {
      if (!!getCompany) setLabelState(getCompany[0]?.Name)
    },
  })

  /*
  ==========================================
  =================FUNCTION=================
  ==========================================
  */
  const totalDocAmt = listData?.eInvoiceConsolidationDetail?.reduce(
    (total, current) => total + Number(current?.DocAmt),
    0
  )

  const totalTaxAmt = listData?.eInvoiceConsolidationDetail?.reduce(
    (total, current) => total + Number(current?.TaxAmt),
    0
  )

  return (
    <>
      {CompanyLoading && <Loading />}
      <MainHeader
        mainBtn={'close'}
        onClick={() =>
          history.push({
            pathname: `/account-receivable/${CompanyID}/consolidate-einvoice`,
          })
        }
        smTitle={smTitle.ACCOUNT_RECEIVABLE}
        title={labelState}
        currency={user?.companyCurrencyCode}
        routeSegments={[
          { name: 'Account Receivable' },
          { name: `Consolidate e-Invoice`, current: true },
        ]}
        rightRouteSegments={[{ name: 'View', current: true }]}
      />

      <DynamicSubHeader
        title={
          <>
            <span className="xsTitle" style={{ color: '#ff9800' }}>
              {listData?.DocNo}
            </span>
          </>
        }
        rightText={
          <span className="c-orange">{formatDate(listData?.DocDate)}</span>
        }
      />

      <ContentWrapper singleDynamicInfo float>
        <CardContents>
          <ARConsolidateEInvoiceDetailContent listEl={listData} />
        </CardContents>

        <CardContents
          section={{
            header: {
              title: `Consolidated Detail(s)`,
              customFontSizeClass: 'xsTitle',
            },
          }}
        >
          <ConsolidateTable
            creditorOrDebtor={'Debtor'}
            data={listData?.eInvoiceConsolidationDetail}
          />
        </CardContents>
      </ContentWrapper>

      <TotalAmountFooter
        taxInfoDetailWithRecord={true}
        docAmt={totalDocAmt}
        totalTaxAmt={totalTaxAmt}
        countRecord={listData?.eInvoiceConsolidationDetail?.length}
      />
    </>
  )
}
